function mark(name) {
	if (typeof performance.mark === 'function') {
		performance.mark('advert - ' + name);
	}
}

module.exports = {
	mark
};
